// What a tenant calls a job: "Work Orders" (default) or "Jobs", from `global_jobs_caption`.
// One kind of the shared term mechanism (./useTerm, which also carries TDs / Service Orders);
// this module keeps the job-specific names its callers import.
import { TERM_KINDS, termFor, type Term } from "./useTerm";

export { useWorkOrderTerm, WORK_ORDERS_TERM, JOBS_TERM } from "./useTerm";

export type WorkOrderTerm = Term;

/** The global config key, as useGlobalConfig() returns it (stored as `global_jobs_caption`). */
export const JOBS_CAPTION_KEY = TERM_KINDS.workorders.key;

/** The words for a `jobs_caption` value: "Jobs" (any case) is Jobs; anything else, Work Orders. */
export const workOrderTerm = (caption: unknown): Term => termFor("workorders", caption);
